var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-box",on:{"click":_vm.showConsultationModal}},[_c('img',{attrs:{"alt":"泰坦智慧","title":"titanos","src":require('../../assets/' + _vm.assetsConfig.consultation.icon)}}),_vm._v(" "),_c('span',[_vm._v("\n    立即咨询\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0088458a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/IconButton.vue
// module id = null
// module chunks = 